import React from 'react'
import PhoneIcon from '@mui/icons-material/Phone';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import { darkModeBackgroud } from '../../../utils/constants';
import { useLanguageStore } from '../../../store/useLanguageStore';
import { useDarkModeStore } from '../../../store/useDarkModeStore';

export const InfoCards = () => {

    const { language } = useLanguageStore();
    const { darkMode } = useDarkModeStore();

    return <React.Fragment>
        <div className='d-flex flex-column align-items-center mt-4 mb-4'>
            <span
                className='ps-2 pe-2'
                style={{ borderRadius: 5, background: '#DFDFFA', color: '#696CFF', fontSize: 14 }}
            >
                {language['Question']}
            </span>
            <h3 className={`mt-3 ${darkMode && 'text-white'}`}>{language['StillQuestion']}</h3>
            <p className={`${darkMode ? 'text-white' : 'text-muted'}`}>{language['CanContactUs']}</p>
        </div>
        <div className='d-flex justify-content-center'>
            <div className='gap-3 d-flex flex-row w-75 mb-3' style={{ height: 165 }}>
                <div
                    className='d-flex flex-column justify-content-center align-items-center w-50'
                    style={{ background: darkMode ? darkModeBackgroud : '#E9EAEE', borderRadius: 3 }}
                >
                    <span
                        className='d-flex align-items-center justify-content-center mb-4'
                        style={{ width: 46, height: 46, background: '#D5D5F1', color: '#8284FC', borderRadius: 5, marginBottom: 10 }}
                    >
                        <PhoneIcon />
                    </span>
                    <span
                        className='fw-bold'
                        style={{ color: darkMode ? 'white' : 'rgb(57,69,82)' }}
                    >
                        +(383) 44 444 444
                    </span>
                    <span
                        className={`${darkMode ? 'text-white' : 'text-muted'}`}
                    >
                        {language['AlwaysHappyToHelp']}
                    </span>
                </div>
                <div
                    className='d-flex flex-column justify-content-center align-items-center w-50'
                    style={{ background: darkMode ? darkModeBackgroud : '#E9EAEE', borderRadius: 3 }}
                >
                    <span
                        className='d-flex align-items-center justify-content-center mb-4'
                        style={{ width: 46, height: 46, background: '#D5D5F1', color: '#8284FC', borderRadius: 5, marginBottom: 10 }}
                    >
                        <MailOutlineIcon />
                    </span>
                    <span
                        className='fw-bold'
                        style={{ color: darkMode ? 'white' : 'rgb(57,69,82)' }}
                    >
                        line-hr@gmail.com
                    </span>
                    <span
                        className={`${darkMode ? 'text-white' : 'text-muted'}`}
                    >
                        {language['BestWayFaster']}
                    </span>
                </div>
            </div>
        </div>
    </React.Fragment>
}
export default InfoCards